var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"content-block"},[_c('div',{staticClass:"content-block__container"},[_c('GalleryBlockGrid',_vm._b({},'GalleryBlockGrid',{ block: _vm.block },false))],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }